import React, { Component } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import axios from "axios";
import VerticalArrow from "./verticalArrow";

class VerticalSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      overlay: false
    };

    this.performSearch = this.performSearch.bind(this);
    this.triggerResize = this.triggerResize.bind(this);
  }

  componentDidMount() {
    var instance = this;

    this.performSearch();

    window.addEventListener("resize", instance.fixCaption);

  }

  triggerResize() {
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      var evt = document.createEvent("UIEvents");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
    } else {
      window.dispatchEvent(new Event("resize"));
    }

    this.fixCaption();
  }

  fixCaption() {
    var instance = document.querySelector("#verticalSlider");
    var bottoms = Array.prototype.slice.call(instance.querySelectorAll(".slide-bottom"));
    var maxHeight = Math.max.apply(null, bottoms.map(function (entry) {
      return entry.offsetHeight;
    }));

    bottoms.forEach((entry) => {
      if (window.innerWidth > 960) {
        entry.style.height = "";
      } else {
        entry.style.height = `${maxHeight}px`;
      }
    });
  }

  performSearch() {
    var instance = this;

    axios
      .get(this.props.api.slickslidesV)
      .then(results => {
        this.setState(
          {
            data: results.data.CarouselList,
            overlay: results.data.EnableOverlay
          },
          function () {
            if (window.innerWidth <= 960) {
              instance.reference.slickNext();
            }

            instance.triggerResize();
          }
        );
      })
      .catch(err => {
        throw err;
      });
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <VerticalArrow direction="prev" />,
      nextArrow: <VerticalArrow direciton="next" />,
      centerMode: false,
      vertical: true,
      verticalSwiping: true,
      beforeChange: (current, next) => {
        if (this.state.data.length === 0) {
          return;
        }

        var item = "banner slide";

        if (window.event == null) {
          item = current > next
            ? "banner up arrow"
            : "banner down arrow";
        } else {
          var target = window.event.target;
          if (target != null && target.nodeName != null) {
            if (target.nodeName.toLowerCase() === "button") {
              item = "banner button circle";
            } else if (target.nodeName.toLowerCase() === "path" && target.parentElement?.parentElement != null) {
              if (target.parentElement.parentElement.classList.contains("rightArrow")) {
                item = "banner down arrow";
              } else {
                item = "banner up arrow";
              }
            } else if (target.nodeName.toLowerCase() === "svg" && target.parentElement != null) {
              if (target.parentElement.classList.contains("rightArrow")) {
                item = "banner down arrow";
              } else {
                item = "banner up arrow";
              }
            }
          }
        }

        methodist.analytics.pushEvent(
          "interface_interactions",
          {
            component: {
              interaction_item: item,
              sc_component_name: "Hero Carousel Banner",
              sc_component_position: next + 1,
              sc_component_title: this.state.data[next].Title
            }
          }
        );
      },
      responsive: [
        {
          breakpoint: 960,
          settings: {
            vertical: false,
            verticalSwiping: false,
            arrows: false,
            appendDots: dots => (
              <div>
                <VerticalArrow
                  direction="prev"
                  onClick={() => {
                    this.reference.slickPrev();
                    return true;
                  }}
                />
                <ul>{dots}</ul>
                <VerticalArrow
                  direction="next"
                  onClick={() => {
                    this.reference.slickNext();
                    return true;
                  }}
                />
              </div>
            )
          }
        }
      ]
    };

    return (
      <div className={this.state.overlay ? "overlay" : "nooverlay"}>
        <Slider ref={reference => (this.reference = reference)} {...settings}>
          {this.state.data.map(slide => (
            <div key={slide.ItemID}>
              <a href={slide.PageUrl}>
                <img src={slide.ImageURL}></img>
              </a>
              <div className="slide-bottom">
                <a className="slide-bottom__inner" href={slide.PageUrl}>
                  {slide.Title && <h2>{slide.Title}</h2>}
                  {slide.SubTitle && <h3>{slide.SubTitle}</h3>}
                  {slide.Teaser && <div className="teaser">{slide.Teaser}</div>}
                </a>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

VerticalSlider.propTypes = {
  api: PropTypes.object
};

export default VerticalSlider;
